export const environment = {
    raygunApiKey: '',
    production: true,
    version: '1.0.0',
    apiUrl: 'https://mm-portal-as-prod-ae--api-stagingtest.azurewebsites.net/api/v2',
    legacyApiUrl: ''
};

